module.exports = __webpack_public_path__ + "static/img/fine.e2f5fc43.png";